export const FetchImageStart = 'canvas/FETCH_IMAGE_START';
export const FetchImageSuccess = 'canvas/FETCH_IMAGE_SUCCESS';
export const FetchImageError = 'canvas/FETCH_IMAGE_ERROR';
export const UpdatePixelStart = 'canvas/UPDATE_PIXEL_START';
export const UpdatePixelSuccess = 'canvas/UPDATE_PIXEL_SUCCESS';
export const UpdatePixelError = 'canvas/UPDATE_PIXEL_ERROR';
export const RegisterContext = 'canvas/REGISTER_CONTEXT';
export const UpdatePosition = 'canvas/UPDATE_POSITION';
export const ClearPosition = 'canvas/CLEAR_POSITION';
export const SetZoom = 'canvas/SET_ZOOM';
export const SetTimeRemaining = 'canvas/SET_TIME_REMAINING';
